import NetworkLogic from "../../Shared/NetworkLogic";
import data = cc.data;
import UIManager from "../../Shared/UIManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class CaiFuBang extends cc.Component {

    @property(cc.Label)
    label: cc.Label = null;

    @property
    text: string = 'hello';
    @property(cc.Label)
    brokerageMoney: cc.Label = null;//本月返佣
    @property(cc.Label)
    shareBonusMoney: cc.Label = null;//分享奖励
    @property(cc.Node)
    content: cc.Node = null;//分享奖励
    onLoad () {}

    start () {
        UIManager.showLoadingUI();
        NetworkLogic.agentGetRanking({},function (data) {
            UIManager.hideLoadingUI();
            console.log("===财富榜数据 data：",data);
            let rankingLength = data.length < this.content.children.length ? data.length : this.content.children.length;
            if  (rankingLength < this.content.children.length){
                for (let i = rankingLength;i < this.content.children.length;i++){
                    this.content.children[i].active = false;
                }
            }
            for (let i = 0;i < rankingLength;i++){
                let child = this.content.children[i];
                child.getChildByName("labTotal").getComponent(cc.Label).string  =  data[i].userId;
                child.getChildByName("labMonthMoney").getComponent(cc.Label).string = data[i].brokerageMoney;
                child.getChildByName("labShareReward").getComponent(cc.Label).string = data[i].shareBonusMoney;
            }
            if (this.content.children.length > data.length){
                for (let j = data.length-1 ;j < this.content.children.length;j++){
                    this.content.children[j].active = false;
                }
            }
        }.bind(this),function () {
            console.log("===财富榜数据错误");
        }.bind(this));

    }

    // update (dt) {}
}
